import { RudderAnalytics, ApiObject, IdentifyTraits } from '@rudderstack/analytics-js';
import { Page, BasicTransport, User, OpCo, Platform } from '../types';

const rudderStackPlaneDomains = {
  'liber': 'liber.se',
  'plantyn': 'plantyn.com',
  'noordhoff': 'noordhoff.nl',
  'Liber': 'liber.se',
  'Plantyn': 'plantyn.com',
  'Noordhoff': 'noordhoff.nl',
};

const PLATFORMS_SUFFIXES = ['PEP', 'SEP'];

export async function createRudderTransport(
  writeKey: string,
  opCo: OpCo,
  platform: Platform,
  rudderanalytics = new RudderAnalytics(),
): Promise<BasicTransport> {
  let platformSuffix = '';
  const nOpCo: NonNullable<OpCo> = opCo || 'noordhoff';

  if (PLATFORMS_SUFFIXES.includes(platform)) {
    platformSuffix = `/${platform.toLowerCase()}`;
  }

  const domain = rudderStackPlaneDomains[nOpCo];
  const controlPlaneUrl = `https://yw5hbhl0awnz.${domain}`;
  const datePlaneUrl = `${controlPlaneUrl}${platformSuffix}`;

  rudderanalytics.load(writeKey, datePlaneUrl, { configUrl: controlPlaneUrl });

  const ms = 10000;
  const fallbackPromise = new Promise(resolve => setTimeout(resolve, ms));
  const readyPromise = new Promise<void>(resolve => rudderanalytics.ready(resolve));

  await Promise.race([fallbackPromise, readyPromise]);

  const renameReservedIdKeyword = (properties: Record<string, unknown>) => {
    if (properties && 'id' in properties) {
      properties['_id'] = properties['id'];
      delete properties['id'];
    }

    return properties;
  };

  const rudderTansport: BasicTransport = {
    async identify(user: User) {
      const { id, ...traits } = user;
      rudderanalytics.identify(id, renameReservedIdKeyword(traits) as IdentifyTraits);
    },

    async page(page: Page) {
      const { category, ...properties } = page;
      rudderanalytics.page(category, page.type, renameReservedIdKeyword(properties) as ApiObject);
    },

    async track(event: string, properties: Record<string, unknown>) {
      rudderanalytics.track(event, renameReservedIdKeyword(properties) as ApiObject);
    },
  };

  return rudderTansport;
}
